import { render } from "./ProvidersTab.vue?vue&type=template&id=d1c545e4&scoped=true"
import script from "./ProvidersTab.vue?vue&type=script&lang=js"
export * from "./ProvidersTab.vue?vue&type=script&lang=js"

import "./ProvidersTab.vue?vue&type=style&index=0&id=d1c545e4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1c545e4"]])

export default __exports__